import { create } from 'zustand';
import type { UserSettings } from '@etown/shared';

interface SettingsState {
  /** null bis zum room:join (Snapshot liefert die eigenen Einstellungen). */
  settings: UserSettings | null;
  setSettings: (settings: UserSettings) => void;
  reset: () => void;
}

/** Persistente Benutzereinstellungen (Anklingeln, Audio-Verarbeitung). */
export const useSettingsStore = create<SettingsState>((set) => ({
  settings: null,
  setSettings: (settings) => set({ settings }),
  reset: () => set({ settings: null }),
}));
